import {testIdProps} from '@github-ui/test-id-props'

import {BaseSettingsPage} from '../../../components/base-settings-page'
import {useBindMemexToDocument} from '../../../hooks/use-bind-memex-to-document'
import styles from './archive-page.module.css'
import {PaginatedArchiveView} from './paginated-archive-view'

export function ArchivePage() {
  useBindMemexToDocument()

  return (
    <BaseSettingsPage {...testIdProps('paginated-archive-page')} className={styles.BaseSettingsPage}>
      <PaginatedArchiveView />
    </BaseSettingsPage>
  )
}

try{ ArchivePage.displayName ||= 'ArchivePage' } catch {}